var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCloseBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3318_84764",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3318_84764)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0018 10.7744L6.4409 14.3353C6.32552 14.4507 6.20133 14.5063 6.06831 14.502C5.93531 14.4977 5.80845 14.4352 5.68773 14.3145C5.56699 14.1938 5.50662 14.0648 5.50662 13.9275C5.50662 13.7902 5.56699 13.6612 5.68773 13.5405L9.22779 10.0004L5.6669 6.43948C5.55151 6.3241 5.49595 6.19644 5.50023 6.05648C5.50449 5.91653 5.56699 5.7862 5.68773 5.66548C5.80845 5.54474 5.93745 5.48438 6.07473 5.48438C6.21201 5.48438 6.34101 5.54474 6.46173 5.66548L10.0018 9.22637L13.5627 5.66548C13.6781 5.55009 13.8058 5.49106 13.9457 5.4884C14.0857 5.48572 14.216 5.54474 14.3367 5.66548C14.4575 5.7862 14.5178 5.9152 14.5178 6.05248C14.5178 6.18976 14.4575 6.31876 14.3367 6.43948L10.7758 10.0004L14.3367 13.5613C14.4521 13.6767 14.5111 13.8009 14.5138 13.9339C14.5165 14.0669 14.4575 14.1938 14.3367 14.3145C14.216 14.4352 14.087 14.4956 13.9497 14.4956C13.8125 14.4956 13.6835 14.4352 13.5627 14.3145L10.0018 10.7744Z",
    fill: "#1C1B1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCloseBlack);
export default __webpack_public_path__ + "static/media/icon_close_black.529b34f8ff8a9501178df20fa4cefb8e.svg";
export { ForwardRef as ReactComponent };